const WhiteListImages = ['image/jpeg', 'image/gif', 'image/png', 'image/webp'];

export default WhiteListImages;
